module.exports = __webpack_public_path__ + "static/media/tamino-weggler.bea689e0.jpg";